<template lang="pug">
v-simple-table
	template(#default)
		tbody
			//- green
			tr(v-if="slopeinfo.slopeGreen")
				td Makkelijk
				td {{slopeinfo.green_percentage}}%
				td
					span.piste-table--bar
						i.piste-green(:style="`width:${slopeinfo.green_percentage}%;`")
				td {{slopeinfo.slopeGreen}}km
			//- blue
			tr(v-if="slopeinfo.slopeBlue")
				td Makkelijk
				td {{slopeinfo.blue_percentage}}%
				td
					span.piste-table--bar
						i.piste-blue(:style="`width:${slopeinfo.blue_percentage}%;`")
				td {{slopeinfo.slopeBlue}}km
			//- red
			tr(v-if="slopeinfo.slopeRed")
				td Gemiddeld
				td {{slopeinfo.red_percentage}}%
				td
					span.piste-table--bar
						i.piste-red(:style="`width:${slopeinfo.red_percentage}%;`")
				td {{slopeinfo.slopeRed}}km
			//- black
			tr(v-if="slopeinfo.slopeBlack")
				td Moeilijk
				td {{slopeinfo.black_percentage}}%
				td
					span.piste-table--bar
						i.piste-black(:style="`width:${slopeinfo.black_percentage}%;`")
				td {{slopeinfo.slopeBlack}}km
			//- total
			tr
				td.font-weight-bold(colspan="3") Totaal km pistes
				td.font-weight-bold {{slopeinfo.total}}km
</template>

<style lang="sass">
.piste-table--bar
	background-color: var(--v-info-base)
	display: block
	text-align: left
	background-color: #f2fbff
	display: block
	position: relative
	line-height: 1
	padding: 0.4rem
	min-width: 100px

	i
		color: #fff
		overflow: hidden
		position: absolute
		font-style: normal
		display: inline-block
		white-space: nowrap
		vertical-align: baseline
		max-width: 100%
		left: 0
		top: 0
		bottom: 0
		height: 100% !important
		text-align: right
		box-sizing: border-box
		padding: 0.4rem 0
		text-indent: 0.4rem

	@each $name, $color in $piste-colors
		.piste-#{$name}
			background-color: $color !important
</style>

<script>
export default {
	props: {
		slopeinfo: {
			type: Object,
			default: () => {}
		}
	}
};
</script>
